// Entrypoint of the application.
import Vue from "vue";
import App from "./App.vue";
import AOS from "aos";
import "aos/dist/aos.css";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// We use bracket here because router is not a default export
import { router } from "./router";

Vue.config.productionTip = false;

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

new Vue({
  router,
  created() {
    AOS.init();
  },
  render: (h) => h(App),
}).$mount("#app");
